const { stats } = require('@fiverr-private/obs');

const PERSEUS_PREFIX = 'services.search_perseus';

module.exports = {
    count(metric, value = 1) { // todo: add 'rate' once its fixed in obs
        return stats.count(PERSEUS_PREFIX, metric, value);
    },

    time(metric, value) {
        return stats.time(PERSEUS_PREFIX, metric, value);
    }
};
